import { createSlice } from '@reduxjs/toolkit';
import {
    getContributorsBreakdown,
    getSkillsBreakdown,
    SLICE_NAME,
    updateContributorStatus
} from './service';
import { IContributorBreakdown, ISkillBreakdown } from 'src/types/community';
import { UserStatus } from 'src/enums/user';

interface initialTypes {
    skillsBreakdown: ISkillBreakdown[];
    skillsLoading: boolean;
    contributorsBreakdown: IContributorBreakdown[];
    contributorsLoading: boolean;
    error: string;
}

const initialState: initialTypes = {
    skillsBreakdown: [],
    skillsLoading: false,
    contributorsBreakdown: [],
    contributorsLoading: false,
    error: ''
};

export const CommunitySlice = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers: {},

    extraReducers: {
        [getSkillsBreakdown.pending.type]: (state) => {
            state.skillsLoading = true;
        },
        [getSkillsBreakdown.fulfilled.type]: (state, { payload }) => {
            state.skillsLoading = false;
            state.skillsBreakdown = payload.breakdown;
        },
        [getSkillsBreakdown.rejected.type]: (state, action) => {
            state.skillsLoading = false;
            state.error = action.payload;
        },
        [getContributorsBreakdown.pending.type]: (state) => {
            state.contributorsLoading = true;
        },
        [getContributorsBreakdown.fulfilled.type]: (state, { payload }) => {
            state.contributorsLoading = false;
            state.contributorsBreakdown = payload.breakdown;
        },
        [getContributorsBreakdown.rejected.type]: (state, action) => {
            state.contributorsLoading = false;
            state.error = action.payload;
        },
        [updateContributorStatus.fulfilled.type]: (state, { payload }) => {
            const row = state.contributorsBreakdown.find(
                (c) => c.id === payload.userId
            );
            if (row) {
                row.status = payload.status as UserStatus;
                row.lastStatusUpdated = new Date().toISOString();
            }
        }
    }
});

export const {} = CommunitySlice.actions;

export default CommunitySlice.reducer;
